// extracted by mini-css-extract-plugin
export var defaultWrapper = "_fd-3";
export var downloadButton = "_fd-4";
export var fileContainer = "_fd-9 _fd-7";
export var fileContainerBase = "_fd-7";
export var fileContainerFixedHeight = "_fd-8 _fd-7";
export var fileInfo = "_fd-5";
export var fileInfoWidthRestricted = "_fd-6";
export var fileType = "_fd-1";
export var fileTypeName = "_fd-2";
export var image = "_fd-0";
export var link = "_fd-b";
export var overflowEllipsis = "_fd-a";